export class AssetTransformer {
  static transform(obj) {
    let asset = {};
    asset.id = obj.id;
    asset.assetName = obj.attributes.asset_name;
    asset.thirdPartyCode = obj.attributes.third_party_code;
    asset.codeId = obj.attributes.code_id;
    asset.status = obj.attributes.status;
    asset.tags = obj.attributes.tags;
    asset.hotspot = obj.attributes.hotspot;
    asset.geometryType = obj.attributes.geometry_type;
    return asset;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/assets/asset.transformer.js